import React from 'react';
import createSvgIcon from '@mui/icons-material/utils/createSvgIcon';
import parseColor from '../util/parseColor';
import { styled } from '../styled';
import { createMmmTheme } from '../Theme';

const greenTheme = createMmmTheme({ mode: 'light', colors: 'default' });

const Icon = createSvgIcon(
  <svg viewBox='0 0 24 24' fill='none' color='inherit' xmlns='http://www.w3.org/2000/svg'>
    <path
      d='M15.5 14h-.79l-.28-.27C15.41 12.59 16 11.11 16 9.5 16 5.91 13.09 3 9.5 3S3 5.91 3 9.5 5.91 16 9.5 16c1.61 0 3.09-.59 4.23-1.57l.27.28v.79l5 4.99L20.49 19zm-6 0C7.01 14 5 11.99 5 9.5S7.01 5 9.5 5 14 7.01 14 9.5 11.99 14 9.5 14'
      fill='var(--search-with-shadow-colors-main)'
    />
    <path
      d='M10,20 a8 1 0 0 1 8,1 a8 1 0 0 1 -8,1a8 1 0 0 1 -8,-1a8 1 0 0 1 8,-1Z'
      opacity='0.3'
      fill='var(--search-with-shadow-colors-shadow)'
    />
  </svg>,
  'SearchWithShadow',
);

export const defaultColors = {
  main: greenTheme.palette.text.primary,
  shadow: greenTheme.palette.text.secondary,
};

const ColoredIcon = styled(Icon, {
  shouldForwardProp: (p) => p !== 'colors',
})(({ theme, colors: overrideColors = {} }) => {
  const colors = {
    ...defaultColors,
    ...overrideColors,
  };
  return ({
    '--search-with-shadow-colors-main': parseColor(theme, colors.main),
    '--search-with-shadow-colors-shadow': parseColor(theme, colors.shadow),
  });
});

export default ColoredIcon;
